import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEasy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Hand_Select_Snap",
	"data-name": "Hand, Select, Snap",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_14021",
		"data-name": "Group 14021",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11596",
				"data-name": "Path 11596",
				d: "M14.414,13.654l2.475-2.475a1.5,1.5,0,0,0,0-2.121h0a1.5,1.5,0,0,0-2.121,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11597",
				"data-name": "Path 11597",
				d: "M16.182,11.886a1.5,1.5,0,0,1,2.121,0h0a1.5,1.5,0,0,1,0,2.121l-2.475,2.475",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11598",
				"data-name": "Path 11598",
				d: "M12.293,11.533l6.01-6.01a1.5,1.5,0,0,0,0-2.121h0a1.5,1.5,0,0,0-2.121,0L8.757,10.827V8.162A1.579,1.579,0,0,0,7.178,6.583h0A1.525,1.525,0,0,0,5.683,7.808L4.56,13.43A7.163,7.163,0,0,0,6.52,19.9h0a7.165,7.165,0,0,0,10.133,0l2-2,1.061-1.061a1.5,1.5,0,0,0,0-2.121h0a1.5,1.5,0,0,0-2.121,0",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11599",
				"data-name": "Path 11599",
				d: "M11.79,2.76,10.71,3.84",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11600",
				"data-name": "Path 11600",
				d: "M2.71,2.76l1,1",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_11601",
				"data-name": "Path 11601",
				d: "M7.25,2V3.41",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_11602",
		"data-name": "Path 11602",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgEasy;
